"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserAcknowledgements = exports.updateSubscriptionFeedTyping = exports.updateAcknowledgements = exports.unsubscribeFeedTyping = exports.typing = exports.subscribeFeedTyping = exports.setUserTyping = exports.setUserAcknowledgements = exports.setUserAcknowledgement = exports.setSelectedFeed = exports.setFeeds = exports.setFeedInput = exports.setFeed = exports.setErrorFeeds = exports.setAnchors = exports.setAnchor = exports.setAcknowledgements = exports.setAcknowledgement = exports.resetUserTyping = exports.requestPostUnicastFeed = exports.requestPostMulticastFeed = exports.requestPostAnchor = exports.requestPostAcknowledgement = exports.requestPatchMulticastFeed = exports.requestGetFeeds = exports.requestGetFeed = exports.requestGetAnchors = exports.requestDeleteFeed = exports.requestDeleteAnchor = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var requestDeleteAnchor = _anchor => ({
  type: types.REQUEST_DELETE_ANCHOR,
  _anchor
});
exports.requestDeleteAnchor = requestDeleteAnchor;
var requestDeleteFeed = _feed => ({
  type: types.REQUEST_DELETE_FEED,
  _feed
});
exports.requestDeleteFeed = requestDeleteFeed;
var requestGetAnchors = () => ({
  type: types.REQUEST_GET_ANCHORS
});
exports.requestGetAnchors = requestGetAnchors;
var requestGetFeed = _feed => ({
  type: types.REQUEST_GET_FEED,
  _feed
});
exports.requestGetFeed = requestGetFeed;
var requestGetFeeds = () => ({
  type: types.REQUEST_GET_FEEDS
});
exports.requestGetFeeds = requestGetFeeds;
var requestPatchMulticastFeed = (_feed, feed, uselessArgument, _users) => ({
  type: types.REQUEST_PATCH_MULTICAST,
  _feed,
  feed,
  _users
});
exports.requestPatchMulticastFeed = requestPatchMulticastFeed;
var requestPostAcknowledgement = _feed => ({
  type: types.REQUEST_POST_ACKNOWLEDGEMENT,
  _feed
});
exports.requestPostAcknowledgement = requestPostAcknowledgement;
var requestPostAnchor = (_feed, _target) => ({
  type: types.REQUEST_POST_ANCHOR,
  _feed,
  _target
});
exports.requestPostAnchor = requestPostAnchor;
var requestPostMulticastFeed = (feed, sharedData, _users) => ({
  type: types.REQUEST_POST_MULTICAST,
  feed,
  sharedData,
  _users
});
exports.requestPostMulticastFeed = requestPostMulticastFeed;
var requestPostUnicastFeed = (_target, sharedData) => ({
  type: types.REQUEST_POST_UNICAST,
  _target,
  sharedData
});
exports.requestPostUnicastFeed = requestPostUnicastFeed;
var resetUserTyping = _feed => ({
  type: types.RESET_USER_TYPING,
  _feed
});
exports.resetUserTyping = resetUserTyping;
var setAcknowledgement = (_feed, acknowledgement) => ({
  type: types.SET_ACKNOWLEDGEMENT,
  _feed,
  acknowledgement
});
exports.setAcknowledgement = setAcknowledgement;
var setAcknowledgements = acknowledgements => ({
  type: types.SET_ACKNOWLEDGEMENTS,
  acknowledgements
});
exports.setAcknowledgements = setAcknowledgements;
var setAnchor = anchor => ({
  type: types.SET_ANCHOR,
  anchor
});
exports.setAnchor = setAnchor;
var setAnchors = anchors => ({
  type: types.SET_ANCHORS,
  anchors
});
exports.setAnchors = setAnchors;
var setErrorFeeds = error => ({
  type: types.SET_ERROR_FEEDS,
  error
});
exports.setErrorFeeds = setErrorFeeds;
var setFeed = _feed => ({
  type: types.SET_FEED,
  _feed
});
exports.setFeed = setFeed;
var setFeedInput = (_feed, content, _feedItem) => ({
  type: types.SET_FEED_INPUT,
  _feed,
  content,
  _feedItem
});
exports.setFeedInput = setFeedInput;
var setFeeds = _feeds => ({
  type: types.SET_FEEDS,
  _feeds
});
exports.setFeeds = setFeeds;
var setSelectedFeed = (_feed, selected) => ({
  type: types.SET_SELECTED_FEED,
  _feed,
  selected
});
exports.setSelectedFeed = setSelectedFeed;
var setUserAcknowledgement = (_feed, acknowledgement) => ({
  type: types.SET_USER_ACKNOWLEDGEMENT,
  _feed,
  acknowledgement
});
exports.setUserAcknowledgement = setUserAcknowledgement;
var setUserAcknowledgements = acknowledgements => ({
  type: types.SET_USER_ACKNOWLEDGEMENTS,
  acknowledgements
});
exports.setUserAcknowledgements = setUserAcknowledgements;
var setUserTyping = payload => ({
  type: types.SET_USER_TYPING,
  payload
});
exports.setUserTyping = setUserTyping;
var subscribeFeedTyping = _feed => ({
  type: types.SUBSCRIBE_FEED_TYPING,
  _feed
});
exports.subscribeFeedTyping = subscribeFeedTyping;
var typing = _feed => ({
  type: types.MY_USER_TYPING,
  _feed
});
exports.typing = typing;
var unsubscribeFeedTyping = _feed => ({
  type: types.UNSUBSCRIBE_FEED_TYPING,
  _feed
});
exports.unsubscribeFeedTyping = unsubscribeFeedTyping;
var updateAcknowledgements = acknowledgements => ({
  type: types.UPDATE_ACKNOWLEDGEMENTS,
  acknowledgements
});
exports.updateAcknowledgements = updateAcknowledgements;
var updateSubscriptionFeedTyping = (_feed, subscribed) => ({
  type: types.UPDATE_SUBSCRIPTION_FEED,
  _feed,
  subscribed
});
exports.updateSubscriptionFeedTyping = updateSubscriptionFeedTyping;
var updateUserAcknowledgements = acknowledgements => ({
  type: types.UPDATE_USER_ACKNOWLEDGEMENTS,
  acknowledgements
});
exports.updateUserAcknowledgements = updateUserAcknowledgements;